<template>
	<div style="width:90%">
		<div class="top">
			<el-button type="primary" @click="editialogVisible();title='新增'">新增</el-button>
		</div>
		<el-table :data="sliderList" stripe style="width: 100%">
			<el-table-column type="index" align="center" label="#" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="content" label="轮播图片" width="180" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.content" :src="scope.row.content" width="50px" @click="
            dialogImageUrl = scope.row.content;
            dialogVisibleImg = true;
          " />
					<div v-else>暂无图标</div>
				</template>
			</el-table-column>
			<el-table-column prop="title" label="标题" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="action" label="类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.action=='good'">商品</span>
					<span v-if="scope.row.action=='url'">链接</span>
					<!-- <span v-if="scope.row.action=='richtext'">富文本</span> -->
				</template>
			</el-table-column>
			<!-- 			<el-table-column prop="type" label="显示位置" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="action" label="类型" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="详情" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row.id)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="orders" label="轮播顺序" width="" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="isEnable" label="是否启用" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<span v-if="scope.row.isEnable==true">是</span>
					<span v-if="scope.row.isEnable==false">否</span>

				</template>
			</el-table-column>
			<el-table-column prop="createDate" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id);title='编辑'">编辑
					</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 查看图片 -->
		<el-dialog :visible.sync="dialogVisibleImg" :close-on-click-modal="false">
			<div style="text-align: center">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="" />
			</div>
			<div style="text-align: center">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 新增轮播图 -->
		<!-- 	<el-dialog :visible.sync="dialogVisibleSwiper" :title="title+'轮播图'" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="标题">
						<el-input type="text" v-model="storeGoodsInfo.title" auto-complete="off" placeholder="请输入标题" />
					</el-form-item>
					<el-form-item label="排序(数字越小越前)">
						<el-input type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="storeGoodsInfo.orders" auto-complete="off" placeholder="请输入排序" />
					</el-form-item>
					<el-form-item label="请选择类型">
						<el-select v-model="storeGoodsInfo.action" class="big" placeholder="请选择">
							<el-option value="good" label="商品">
							</el-option>
							<el-option value="url" label="链接">
							</el-option>
							<el-option value="richtext" label="富文本">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="请选择显示位置">
						<el-select v-model="storeGoodsInfo.type" class="big" placeholder="请选择">
							<el-option value="首页" label="首页">
							</el-option>
							<el-option value="兑换" label="兑换">
							</el-option>
						</el-select>
					</el-form-item>
					<div style="border: 1px solid lightgrey;padding: 10px;" v-if="storeGoodsInfo.action=='good'">
						<div style="text-align: left;">
							选择商品：
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="商品名称">
								<el-input type="text" clearable v-model="storeGoodsInfo.goodsName1"
									placeholder="请输入商品名称(搜索条件)" />
							</el-form-item>
							<el-form-item label="商品编号">
								<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode"
									placeholder="请输入商品编号(搜索条件)" />
							</el-form-item>
							<el-form-item label="搜索按钮">
								<el-button type="primary" @click="searchStore">搜 索</el-button>
							</el-form-item>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="选择商品">
								<el-select v-model="storeGoodsInfo.url" class="big" placeholder="请选择"
									@change="getStoreAndUsers" clearable>
									<el-option v-for="item in accountList" :key="item.id" :value="item.id"
										:label="item.goodsName+'('+item.goodsCode+')'">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="链接" v-if="storeGoodsInfo.action=='url'">
						<el-input type="text" v-model="storeGoodsInfo.url" auto-complete="off" placeholder="请输入跳转链接" />
					</el-form-item>
					<el-form-item v-if="storeGoodsInfo.action=='richtext'" label="通知内容">
						<div id="lpc-quill" class="quill">
							<el-upload v-show="false" ref="upload" class="upload-demo" :action="httpUrl"
								:on-success="upScuccess" :on-error="uploadError" />
							<quill-editor v-model="storeGoodsInfo.url" ref="myQuillEditor" class="editer"
								:options="editorOption" @ready="onEditorReady($event)">
							</quill-editor>
						</div>
					</el-form-item>

					<el-form-item label="是否启用" class="redItem">
						<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="是否跳转" class="redItem">
						<el-switch v-model="storeGoodsInfo.isJump" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="轮播图片(限制1张)，建议尺寸在16:9" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :before-upload="beforeUpload" :show-file-list="true"
							:file-list="fileList" :on-success="onSuccess" multiple :limit="1" :on-exceed="handleExceed">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-button type="primary" round @click="submit">提交</el-button>
				</el-form>
			</div>
		</el-dialog> -->

		<!-- 编辑修改 -->
		<el-dialog :visible.sync="editialogVisibleSwiper" :title="title+'轮播图'" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="标题">
						<el-input type="text" v-model="storeGoodsInfo.title" auto-complete="off" placeholder="请输入标题" />
					</el-form-item>
					<el-form-item label="排序">
						<el-input type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="storeGoodsInfo.orders" auto-complete="off" placeholder="请输入排序" />
					</el-form-item>
					<!-- <el-form-item label="请选择类型">
						<el-select v-model="storeGoodsInfo.type" class="big" placeholder="请选择"
							@change="getStoreAndUser">
							<el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="请选择类型">
						<el-select v-model="storeGoodsInfo.action" class="big" placeholder="请选择">
							<el-option value="good" label="商品">
							</el-option>
							<el-option value="url" label="链接">
							</el-option>
							<!-- 		<el-option value="richtext" label="富文本">
							</el-option> -->
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="请选择显示位置">
						<el-select v-model="storeGoodsInfo.type" class="big" placeholder="请选择">
							<el-option value="首页" label="首页">
							</el-option>
							<el-option value="兑换" label="兑换">
							</el-option>
						</el-select>
					</el-form-item> -->

					<div style="border: 1px solid lightgrey;padding: 10px;" v-if="storeGoodsInfo.action=='good'">
						<div style="text-align: left;">
							选择商品：
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="商品名称">
								<el-input type="text" clearable v-model="storeGoodsInfo.goodsName1"
									placeholder="请输入商品名称(搜索条件)" />
							</el-form-item>
							<el-form-item label="商品编号">
								<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode"
									placeholder="请输入商品编号(搜索条件)" />
							</el-form-item>
							<el-form-item label="搜索按钮">
								<el-button type="primary" @click="searchStore">搜 索</el-button>
							</el-form-item>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="选择商品">
								<el-select v-model="storeGoodsInfo.url" class="big" placeholder="请选择"
									@change="getStoreAndUsers" clearable>
									<el-option v-for="item in accountList" :key="item.id" :value="item.id"
										:label="item.goodsName+'('+item.goodsCode+')'">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>

					<el-form-item label="链接" v-if="storeGoodsInfo.action=='url'">
						<el-input type="text" v-model="storeGoodsInfo.url" auto-complete="off" placeholder="请输入跳转链接" />
					</el-form-item>

					<!-- 		<el-form-item v-if="storeGoodsInfo.action=='richtext'" label="通知内容">
						<div id="lpc-quill" class="quill">
							<el-upload v-show="false" ref="upload" class="upload-demo" :action="httpUrl"
								:before-upload="beforeUpload" :on-success="upScuccess" :on-error="uploadError" />
							<quill-editor v-model="storeGoodsInfo.url" ref="myQuillEditor" class="editer"
								:options="editorOption" @ready="onEditorReady($event)">
							</quill-editor>
						</div>
					</el-form-item> -->

					<el-form-item label="url地址">
						<el-input type="text" v-model="storeGoodsInfo.url" auto-complete="off"
							placeholder="请输入外部链接地址" />
					</el-form-item>
					<el-form-item label="是否启用" class="redItem">
						<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="是否跳转" class="redItem">
						<el-switch v-model="storeGoodsInfo.isJump" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-form-item label="轮播图片(限制1张)" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<el-upload :action="httpUrl" list-type="picture-card" :before-upload="beforeUploaden"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="fileList"
							:show-file-list="true" :on-success="onSuccess" multiple :limit="1">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-button type="primary" round @click="submit" v-if="title=='新增'">新增</el-button>
					<el-button type="primary" round @click="submitmodify" v-if="title=='编辑'">编辑</el-button>
				</el-form>
			</div>

		</el-dialog>
		<!-- 查看 -->
		<el-dialog title="提示" :visible.sync="showContentDialog" width="50%" :close-on-click-modal="false">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>


<script>
	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		components: {
			quillEditor
		},
		data() {
			return {
				sliderList: [],
				storeGoodsInfoGoodsName: '',
				goodsImages: [],
				accountList: [],
				storeGoodsInfo: {
					isJump: true,
					isEnable: false
				},

				httpUrl: urls,
				fileList: [],
				types: [],
				page: {
					pageNum: 1,
					pageSize: 10,

				},
				id: '',
				title: '',
				sliderlist: {},
				dialogImageUrl: "",
				dialogVisibleImg: false,
				dialogVisibleSwiper: false,
				editialogVisibleSwiper: false,
				showContentDialog: false,
				contentValue: "",
				editorOption: { // 富文本编辑器配置
					placeholder: '请输入内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function(value) {
									if (value) {
										document.querySelector('#lpc-quill .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				},
			};

		},
		methods: {
			addDialogClose() {
				this.fileList = []
				this.storeGoodsInfo = ''
			},
			showContent(e) {
				this.$api.sysSliderInfo(e).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.contentValue = res.data.url
					}
				})

				// this.contentValue = e
				this.showContentDialog = true
			},
			onSuccess(response, file, fileList) {
				this.storeGoodsInfo.content = response.message
				// console.log('ssssss',response.data);
			},
			handleRemove(file, fileList) {
				if (file.url) {
					// console.log('sds',file.url);
					this.storeGoodsInfo.content.remove(file.url);
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				// console.log('sds', file.url);
				this.dialogVisibleImg = true;
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message({
						message: "上传图片大小不能超过 8MB!",
						type: 'error'
					});
				}
				return isLt2M;
			},
			sysSliderList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
				};
				this.$api.sysSliderList(this.$encrypt(data)).then((res) => {
					// console.log(res);
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == "success") {
						this.sliderList = res.data.list;
						this.sliderlist = res.data
						// console.log("ss", this.sliderlist);
					}
				});
				// this.$api.getStoreGoodsList({}).then((res) => {
				// 	if (res.state == 'success') {
				// 		if (res.data.list[0]) {
				// 			this.storeGoodsInfo.goodsName = res.data.list[0].goodsName
				// 			this.storeGoodsInfo.objId = res.data.list[0].id
				// 		}
				// 	}
				// })
			},
			addCarousel() {
				this.$api.getStoreGoodsList({}).then((res) => {
					if (res.state == 'success') {
						// console.log(parseInt(res.data.list[0].id))
						this.storeGoodsInfo = {
							url: res.data.list[0].id
						}
						this.accountList = res.data.list
					}
				})
				this.dialogVisibleSwiper = true
				// console.log(this.storeGoodsInfo)
			},
			// 新增
			submit() {
				let data = {
					title: this.storeGoodsInfo.title,
					orders: this.storeGoodsInfo.orders,
					type: this.storeGoodsInfo.type,
					action: this.storeGoodsInfo.action,
					content: this.storeGoodsInfo.content,
					isEnable: this.storeGoodsInfo.isEnable,
					url: this.storeGoodsInfo.url,
					isJump: this.storeGoodsInfo.isJump
					// id:this.id
				}
				this.$api.addSysSliderInf(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editialogVisibleSwiper = false
						this.sysSliderList();
						this.storeGoodsInfo = ''
						this.fileList = []
					} else {
						this.$message.error(res.message);
						this.editialogVisibleSwiper = false
					}
					// this.editialogVisibleSwiper = false
				})
			},
			// 搜索
			searchStore() {
				let data = {
					goodsCode: this.storeGoodsInfo.goodsCode,
					goodsName: this.storeGoodsInfo.goodsName1,
				}
				this.$api.getStoreGoodsList(data).then((res) => {
					if (res.state == 'success') {
						this.storeGoodsInfo.goodsName = res.data.list[0].goodsName
						this.storeGoodsInfo.url = res.data.list[0].id
						this.accountList = res.data.list

					}
				})

			},
			getStoreAndUsers(val) {
				this.storeGoodsInfo.url = val
			},
			// 删除
			toDelete(e) {
				var str = "此操作将删除该轮播, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delSysSliderInfo(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.sysSliderList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 编辑
			editialogVisible(e) {
				if (e) {
					this.title = '编辑'
					this.id = e
					this.$api.sysSliderInfo(e).then((res) => {
						res.data=JSON.parse(this.$decrypt(res.data)).data
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							if (res.data.action == 'good') {
								this.storeGoodsInfo.url = parseInt(res.data.url)
							}
							this.storeGoodsInfo.isEnable = res.data.isEnable
							if (this.fileList.length < 1) {
								this.fileList.push({
									name: res.data.content,
									url: res.data.content
								});
							}
						}
					})
				}
				this.$api.getStoreGoodsList({}).then((res) => {
					if (res.state == 'success') {
						this.accountList = res.data.list
					}
				})
				this.editialogVisibleSwiper = true
			},
			submitmodify() {
				this.storeGoodsInfo.id = this.id
				let data = this.storeGoodsInfo
				this.$api.editSysSliderInfo(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editialogVisibleSwiper = false
						this.sysSliderList();

					} else {
						this.$message.error(res.message);
					}
				})
			},

			getStoreAndType() {
				this.$api.findSysSliderTypeList().then((res) => {
					if (res.state == 'success') {
						this.types = res.data.list
					}
				})
			},
			getStoreAndUser(val) {
				this.storeGoodsInfo.type = val
			},
			pageChange(data) {
				this.page.pageNum = data
				this.sysSliderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.sysSliderList()
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
				}
				return isLt2M;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadError() {
				this.$message.error('图片上传失败')
			},
			onEditorReady(editor) { // 准备编辑器
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
				}
				return isLt2M;
			},
			upScuccessen(res, file) {
				const quill = this.$refs.myQuillEditoren.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadErroren() {
				this.$message.error('图片上传失败')
			},
			onEditorReadyen(editor) { // 准备编辑器
			},
		},

		created() {
			this.sysSliderList();
			// this.sysSliderInfo()
		},
	};
</script>

<style>
	.top {
		padding: 30px 0;
		margin-left: 50px;
	}

	.el-form-item__content {
		display: flex;
	}

	/* .el-form-item redItem{
  display: flex;
  align-items: center;
} */
	.switchss {
		margin-top: 10px;

	}
</style>
